module.exports = __webpack_public_path__ + "156191ccf4cbd700b47f34d878ce5f39.woff2";